import { useState, useEffect } from 'react';
import { TicketsResponse, TicketFilters} from '../../services/SalesRep/salesrepTicketsService'
import {Bounce, toast} from "react-toastify";
import {getCompletedTickets} from "../../services/Administrative/ticketsService";

interface UseFetchTicketsProps {
    filters?: TicketFilters;
}

export const useGetCompletedTickets = ({ filters = {} }: UseFetchTicketsProps & { clearFilters?: () => void }) => {
    const [tickets, setTickets] = useState<any[]>([]);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(0);

    useEffect(() => {
        const fetchTickets = async () => {
            setIsLoading(true);
            try {
                const response: TicketsResponse = await getCompletedTickets(page, filters);
                setPage(response.page);
                setTickets(response.tickets);
                setTotalPages(response.totalPages);
            } catch (error: any) {
                console.error('Error fetching tickets:', error);
                if (error.response) {
                    if (error.response.status === 404) {
                        toast.warning(
                            `${error.response.data.message}. Por favor, verifique o limpie los filtros`,
                            {
                                position: 'top-right',
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false,
                                theme: 'colored',
                                transition: Bounce,
                            }
                        );
                    } else {
                        toast.error("Error al obtener los tickets.", {
                            position: 'top-right',
                            autoClose: 4000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false,
                            theme: 'colored',
                            transition: Bounce,
                        });
                    }
                } else {
                    toast.error("Error al obtener los tickets.", {
                        position: 'top-right',
                        autoClose: 4000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false,
                        theme: 'colored',
                        transition: Bounce,
                    });
                }
            } finally {
                setTimeout(() => {
                    setIsLoading(false);
                }, 600);
            }
        };
        fetchTickets();
    }, [page, filters]);

    return { tickets, totalPages, isLoading, page, setPage };
};
